import React from "react";
import {Toggle} from "@rescui/toggle";
import {useImages} from "../../contexts/images";

/**
 * The logo on/off control for the social channel. The toggle reads as "show
 * the logo", so it is checked when `logoHidden` is false.
 *
 * The warning that goes with a hidden logo is a separate export: the toggle
 * sits in the layout panel's control row, and a block of text cannot share
 * that row. Both read `logoHidden` from the images context, so they cannot
 * drift apart.
 */
export default function LogoToggle() {
  const {logoHidden, editLogoHidden} = useImages();

  return (
    <div className="localization">
      <span className="label">Logo</span>
      <Toggle
        checked={!logoHidden}
        className="font-toggle"
        onChange={(e) => {
          editLogoHidden(!e.target.checked);
        }}
      />
    </div>
  );
}

/** Shown under the control row while the logo is hidden. */
export function LogoHiddenWarning() {
  const {logoHidden} = useImages();
  if (!logoHidden) return null;

  return (
    <div className="logo-hidden-warning">
      Warning: the logo is hidden on the banners. Please note that these banners can only be used on
      JetBrains social media accounts, where the logo is already in the profile picture.
    </div>
  );
}
